import React, { useEffect, useState } from "react";
import "./ThankYou.scss";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cart from "../Cart/Cart";
import Spinner from "../Spinner/Spinner";
import { useLocation } from "react-router";
import nvCookieHelpers from "../../services/cookieService";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from "../../contexts/LoaderContext";
// import Invoice from "./Invoice";
// import { saveAs } from 'file-saver';
import html2pdf from "html2pdf.js";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import HeaderNavbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
// import { useAuth } from "../../services/authService";
import { config } from "../../config";
import { useLocalization } from "../../contexts/LocalizationContext";


const isDownload: boolean = false;
const isThanks: boolean = true;
const isVerify: boolean = false;

const ThankYou: React.FC = () => {
  const { locale } = useLocalization();
  const { t } = useTranslation();
  const { state } = useLocation();
  let orderData;
  if (state) {
    if (state.orderData) {
      orderData = state.orderData;
    } else if (state?.cartResult) {
      orderData = state.cartResult;
    }
  }
  // const { InvalidateCheckoutSession } = useAuth();
  const [cartData, setCartData] = useState<any>();
  const [shippingInfoName, setshippingInfoName] = useState("");
  const [shippingAddress, setshippingAddress] = useState("");
  const [shippingCountry, setshippingCountry] = useState("");
  const [shippingContact, setshippingContact] = useState("");
  // const [isMrktplceLoggedIn, setIsMrktplceLoggedIn] = useState<boolean>(false);
  const navigate = useNavigate();
  const [orderEmail, setOrderEmail] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [orderTotal, setOrderTotal] = useState("0");
  const [isDigital, setIsDigital] = useState(false);
  const [category, setCategory] = useState<string>();
  const { setItemsInCart, isPartner, isDirect, setIsThanks, setIsVerify, setIsDownload, setOrderSubmit } = useHeaderMenu();
  const { isLoading, showLoader, hideLoader } = useLoader();
  const headingWithSymbol = t("nvidiaSI_INREVIEW_GFN_CONTENT_1");
  const paragraphWithLink = t("ORDER_INSTRUCTIONS_SO_2").replace('{0}', config.bcSupportUrl);
  const sanitizedText = DOMPurify.sanitize(paragraphWithLink, {
    ALLOWED_TAGS: ['a'], // Allow anchor tags
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'], // Allow necessary attributes including target
  });
  const sanitizedSymbol = DOMPurify.sanitize(headingWithSymbol);
  let orderObj: any = nvCookieHelpers.getCookie('nvHeadless');
  let productId: any;
  // let cartObject:any;
  console.log('ORDER DATA', orderData);

  const currentDate = new Date().toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });

  const emptyCart = (msg: string) => {
    navigate(`/${locale}/software/cart/empty`, { state: { msg } });
  }
  // const handleSessionInvalidateError = useCallback(() => {
  //   console.log('Something went Wrong');
  //   emptyCart(t('VERIFY_PAGE_ERROR_MESSAGE'));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const invalidateSession = () => {
  //   showLoader();
  //   try {
  //     InvalidateCheckoutSession(handleSessionInvalidateSuccess, handleSessionInvalidateError);
  //   } catch (error) {
  //     hideLoader();
  //   }
  // }

  useEffect(() => {
    setIsThanks(true);
    setIsVerify(false);
    if (orderData) {
      setIsDownload(orderData.isDigital);
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let tmpcart = orderObj ? orderObj['cart'] : [];
    // if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
    //   //invalidateSession();
    // }
    if (orderData) {
      showLoader();
      if (orderData?.order?.orderState === 'accepted' || orderData?.order?.orderState === "Submitted") {
        setOrderSubmit(true)
      }
      setCartData(orderData);
      let subTotal = orderData["pricing"]["formattedOrderTotal"];
      setOrderNumber(orderData["order"]["id"]);
      setOrderEmail(orderData["billingAddress"]["emailAddress"]);
      setOrderTotal(subTotal);
      let infoNameShipping =
        (orderData.shippingAddress?.firstName || "") +
        " " +
        (orderData.shippingAddress?.lastName || "");

      let addressShipping =
        (orderData.shippingAddress?.line1 ? orderData.shippingAddress?.line1 + ', ' : '') +
        (orderData.shippingAddress?.line2 ? orderData.shippingAddress?.line2 + ', ' : '') +
        (orderData.shippingAddress?.city ? orderData.shippingAddress?.city + ', ' : '') +
        (orderData.shippingAddress?.countrySubdivision ? orderData.shippingAddress?.countrySubdivision + ', ' : '') +
        ((locale !== 'en-hk' && locale !== 'en-me') ? orderData.shippingAddress?.postalCode : '');
      setshippingInfoName(infoNameShipping);
      setshippingAddress(addressShipping);
      setshippingCountry(orderData.shippingAddress?.country || "");
      setshippingContact(orderData.shippingAddress?.phoneNumber || "");
      let cartState = orderData?.cartItems?.cartItem;
      if (cartState && cartState.length > 0) {
        // Filter tmpcart items based on cartState product IDs
        cartState.forEach(cartItem => {
          if (productId && tmpcart.length) {
            tmpcart = tmpcart.filter(item => productId !== item.id);
          }


        });
      }

      const items = orderData?.cartItems.cartItem.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(cartItem.pricing.formattedListPrice.replace('$', '')), // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));
      const localeFromPath = window.location.pathname.split('/')[1]; // Extract 'en-us'
      const formattedLocale = localeFromPath.replace('-', '_').toLowerCase().replace(/^[a-z]{2}/, match => match.toUpperCase());
      // Extract product IDs
      const productIds = orderData?.cartItems.cartItem.map(item => item.product.id);

      setIsDigital(orderData?.cartItems.cartItem.map(item => item.product.productType)[0] === 'DIGITAL')
      setCategory(orderData?.category?.toUpperCase())
      // Join with colon only if multiple IDs exist
      const pids = productIds.length > 1 ? productIds.join(':') : productIds[0].toString();
      const cart = {
        customerID: "",
        orderID: orderData ? orderData['cartId'] : '',
        currencyCode: orderData ? orderData['pricing']['orderTotal']['currency'] : '',
        loginState: nvCookieHelpers.getCookie('isUserLoggedIn') ? 'loggedIn' : 'guest',
        storeLocale: formattedLocale,
        isDirect: isDirect,
        promoCode: "no",
        // paymentMethod: orderData['paymentMethod']['type'],
        saveCardOption: false, // Assuming this is a boolean
        // cardType: orderData['paymentMethod']['type'],
        shippingMethod: orderData ? orderData.shippingMethod?.description : "",
        items: items
      }
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
      console.log((window as any)?.CartOrder);

      if (typeof window !== "undefined" && typeof (window as any)?.OrderOmniProd === "function") {
        (window as any)?.OrderOmniProd(this, 'event10,purchase', 'checkout:order:', 'success', pids);
      } else {
        console.error("OrderOmniProd function is not available.");
        (window as any)?.OrderOmniProd(this, 'event10', 'checkout:order:', 'failed', pids) // Please pass product ID.
      }
      hideLoader();
    } else {
      // OrderOmniProd(this, 'event10','checkout:order:','failed',productId) // Please pass product ID.
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    let cookieItem = { cart: [], lastAction: null };
    console.log('Updated Cookie Item', tmpcart);
    if (tmpcart && tmpcart.length) {
      if (orderObj && orderObj['activeTab']) {
        tmpcart = tmpcart.filter(item => orderObj['activeTab'] !== item.category);
      }
      cookieItem = { cart: tmpcart, lastAction: null };
    }
    setItemsInCart(0);
    sessionStorage.removeItem("type");
    sessionStorage.removeItem("guest");
    sessionStorage.removeItem("customer");
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("register");
    sessionStorage.removeItem("payment");
    nvCookieHelpers.setCookie("nvHeadless", JSON.stringify(cookieItem));
    nvCookieHelpers.deleteCookie("checkout");
    sessionStorage.removeItem("checkoutClicked");
    nvCookieHelpers.deleteCookie("sessionDetails");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  const getInvoice = () => {
    const element = document.getElementById("invoice");
    if (element) {
      element.style.display = "block";
      const opt = {
        dpi: 300,
        margin: 1,
        render: 'html',
        filename: 'NVIDIA Online Store - Invoice.pdf', // Specify the filename here
      };
      html2pdf().from(element).set(opt).save();
      setTimeout(() => {
        element.style.display = "none";
      }, 100);
    }
  };
  const returnStore = () => {
    let decodedURL = locale === 'en-hk' ? 'https://www.nvidia.cn/geforce/' : locale === 'en-ph' ? 'https://marketplace.nvidia.com/en-ph/consumer/' : locale === 'en-af' ? 'https://marketplace.nvidia.com/en-eu/consumer/' : locale === 'es-la' ? 'https://marketplace.nvidia.com/en-us/consumer/' :`https://marketplace.nvidia.com/${locale === 'en-me' ? 'en-eu' : locale}`;
    if (category === 'ACADEMY') {
      decodedURL = `https://academy.nvidia.com/`;
    } else if (category === 'DLI') {
      decodedURL = `https://learn.nvidia.com/`;
    } else {
      if (decodedURL && decodedURL !== "") {
        window.location.href = decodedURL;
      }
    }

  };

  const initialValidationErrors: Record<string, string> = {};
  return (
    <>
      <div className="Return" id="orderProcessed">
        {isLoading ? (
          <Spinner />
        ) : (
          <Container role="main" aria-labelledby="thank-you-page-heading">
            <Row xs={'auto'} md={'auto'}>
              <Col md={6} className="detailWrapper" role="region" aria-labelledby="order-details-heading">
                <h3 id="order-details-heading" className="visually-hidden">{t('ORDER_DETAILS')}</h3>
                {/* <div id="pdf-content" style={{display:'none'}}>
                            <Invoice />
                        </div> */}
                <h2
                  id="thank-you-page-heading"
                  className="pageHeading"
                  dangerouslySetInnerHTML={{ __html: sanitizedSymbol }}
                />
                <div className="orderInfo mb-4" role="region" aria-labelledby="order-info-heading">
                  <h3 id="order-info-heading" className="">{t("ORDERINFO01")}</h3>
                  <address>
                    <p className="orderInfoName">
                      <b>{t("ORDER_DATE_COLON")}</b>{" "}
                      <span>{currentDate}</span>
                    </p>
                    <p className="orderNumber">
                      <b>{t("ORDER_NUMBER_COLON")}</b>{" "}
                      <span>{orderNumber}</span>
                    </p>
                    <p className="orderTotal">
                      <b>{t("ORDER_TOTAL_COLON")}</b> <span>{orderTotal}</span>
                    </p>
                    {/* <p>{t("INVOICE_TYPAGE_SOFT_DESCRIPTOR")}NVIDIA".</p> */}
                  </address>
                  {(orderData?.partner && orderData?.order?.orderState === 'accepted') && <Button
                    className="continue viewInvoice"
                    onClick={getInvoice}
                    aria-label={t("BTN_VIEW_INVOICE")}
                  >
                    <b>{t("BTN_VIEW_INVOICE")}</b>
                  </Button>}
                  {!orderData?.partner && orderData?.order?.orderState === "Submitted" && <Button
                    className="continue viewInvoice"
                    onClick={getInvoice}
                    aria-label={t("BTN_VIEW_INVOICE")}
                  >
                    <b>{t("BTN_VIEW_INVOICE")}</b>
                  </Button>}
                  {/*{isMrktplceLoggedIn && <Button className="continue viewInvoice" onClick={getInvoice}>
                    <b>{t("BTN_VIEW_INVOICE")}</b>
                  </Button>} */}
                </div>
                <div className="orderInstruction mb-4" role="region" aria-labelledby="contact-info-heading">
                  <h3 id="contact-info-heading" className="">{t("DR_CONTACT_INFORMATION_PAGE_TITLE")}</h3>
                  <p>
                    <b>{orderEmail}</b>
                  </p>
                  <p>{t("EMAIL_ORDER_DETAILS")}</p>
                </div>
                {!isDigital && (<div className="mb-4" role="region" aria-labelledby="shipping-address-heading">
                  <h3 id="shipping-address-heading" className="">{t("SHIPPING_ADDRESS")}</h3>
                  <address>
                    <p className="shippingInfoName">
                      <b>{shippingInfoName}</b>
                    </p>
                    <p className="shippingAddress">
                      {shippingAddress}
                    </p>
                    <p className="shippingCountry">{shippingCountry}</p>
                    {!isPartner && <span className="shippingContact">{shippingContact}</span>}
                  </address>
                </div>)}

                <div className="orderInstruction orderDisclaimer mb-4" role="region" aria-labelledby="order-instructions-heading">
                  <h3 id="order-instructions-heading" className="">{t("ORDER_INSTRUCTIONS_TITLE")}</h3>
                  <div role="contentinfo" aria-labelledby="order-instructions-heading">
                    <p dangerouslySetInnerHTML={{ __html: sanitizedText }} />
                  </div>
                </div>
              </Col>
              <Col md={{ span: 5, offset: 1 }} role="complementary" aria-labelledby="order-summary-heading">
                <Card className="reviewOrder">
                  <h3 id="order-summary-heading" className="visually-hidden">{t('ORDER_SUMMARY')}</h3>
                  {cartData && (
                    <Cart
                      onCartChange={(e) => { }}
                      validationErrors={initialValidationErrors}
                      onPromoChange={(e) => { }}
                      onPromoSubmit={(e) => { }}
                      onPromoDelete={(e) => { }}
                      isDownload={isDownload}
                      isVerify={isVerify}
                      isThanks={isThanks}
                      cartData={cartData}
                      promoCodeError={false}
                    />
                  )}
                </Card>
              </Col>
              <Col md={6} role="region" aria-labelledby="return-to-store-heading">
                <h3 id="return-to-store-heading" className="visually-hidden">{t('RETURN_TO_STORE')}</h3>
                <Button
                  type="button"
                  variant="success"
                  className="btn-green submitOrder mt-2 return-to-store-btn"
                  onClick={returnStore}
                  aria-label={t('RETURN_TO_STORE')}
                >
                  {t('RETURN_TO_STORE')}
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <div className="Return" id="invoice">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Container fluid={true}>
              <HeaderNavbar />
            </Container>
            <Container>
              <Row xs={'auto'} md={'auto'}>
                <Col md={12} className="detailWrapper">
                  <h2 className="pageHeading">INVOICE</h2>
                </Col>
                <Col md={3} className="detailWrapper">
                  <div className="orderInfo mb-4">
                    <h3 className="section-title">{t("ORDERINFO01")}</h3>
                    <address>
                      <p className="orderInfoName">
                        <b>{t("ORDER_DATE_COLON")}</b>{" "}
                        <span>
                          {currentDate}
                        </span>
                      </p>
                      <p className="orderNumber mt-2">
                        <b>{t("ORDER_NUMBER_COLON")}</b>{" "}
                        <span>{orderNumber}</span>
                      </p>
                    </address>
                  </div>
                </Col>
                <Col md={3} className="detailWrapper">
                  <div className="orderInstruction mb-4">
                    <h3 className="section-title">
                      {t("BILLING_INFORMATION")}
                    </h3>
                    <p className="shippingInfoName">
                      {shippingInfoName}
                    </p>
                    <p className="mt-2">
                      {shippingAddress}
                    </p>
                    <p className="mt-2">
                      {orderEmail}
                    </p>
                  </div>
                </Col>
                <Col md={3} className="detailWrapper">
                  <div className="orderInstruction mb-4">
                    <h3 className="section-title">
                      {t("SHIPPING_INFORMATION")}
                    </h3>
                    <p className="shippingInfoName">
                      {shippingInfoName}
                    </p>
                    <p className="mt-2">
                      {shippingAddress}
                    </p>
                  </div>
                </Col>
                <Col md={12}>
                  <Card className="reviewOrder">
                    {cartData && (
                      <Cart
                        onCartChange={(e) => { }}
                        validationErrors={initialValidationErrors}
                        onPromoChange={(e) => { }}
                        onPromoSubmit={(e) => { }}
                        onPromoDelete={(e) => { }}
                        isDownload={isDownload}
                        isVerify={isVerify}
                        isThanks={isThanks}
                        cartData={cartData}
                        promoCodeError={false}
                      />
                    )}
                  </Card>
                </Col>
                <Col md={12}>
                  <Button
                    type="button"
                    variant="success"
                    className="btn-green submitOrder mt-3"
                    onClick={returnStore}
                  > Back
                  </Button>
                </Col>
                <Footer />
              </Row>
            </Container>
          </>
        )}
      </div>
    </>
  );
};

export default ThankYou;